export enum ProductDetailsErrors {
    Default = 'PRODUCT_DETAILS_ERROR',
    Promotion = 'PRODUCT_PROMOTION_INFO_ERROR',
}
